import {
  EVENT_INTLCHANGE_TYPE,
  isIntlChangeEvent,
} from '@tokenized/sdk-js-private';
import { useEffect, useState } from 'react';
import { useTokenizedApi } from '../useTokenizedApi';

/** @category Internationalization */
export function useLocaleCurrency() {
  const tokenizedApi = useTokenizedApi();
  const [currencyCode, setCurrencyCode] = useState<string>(
    tokenizedApi?.intl.getLocaleCurrencyCode(),
  );

  useEffect(() => {
    if (tokenizedApi) {
      const updateLocale: EventListener = (event) => {
        if (isIntlChangeEvent(event)) {
          setCurrencyCode(event.detail.currencyCode);
        }
      };
      tokenizedApi.intl.addEventListener(EVENT_INTLCHANGE_TYPE, updateLocale);
      return () =>
        tokenizedApi.intl.removeEventListener(
          EVENT_INTLCHANGE_TYPE,
          updateLocale,
        );
    }
  }, [tokenizedApi, tokenizedApi?.intl]);

  return currencyCode;
}
